"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudienceRequestsClusterizationServiceServer = exports.AudienceRequestsClusterizationServiceDispatcher = exports.AudienceRequestsClusterizationServiceClient = void 0;
var octopus_common_1 = require("@playq/octopus-common");
var services_shared_1 = require("@playq/services-shared");
var services_beetle_1 = require("@playq/services-beetle");
var irt_1 = require("@playq/irt");
var InCreate = (function () {
    function InCreate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.clusterTask = new services_beetle_1.ClusterizationTaskCreateData(data.clusterTask);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InCreate.prototype, "clusterTask", {
        get: function () {
            return this._clusterTask;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field clusterTask is not optional');
            }
            this._clusterTask = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InCreate.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InCreate.prototype.serialize = function () {
        return {
            clusterTask: this.clusterTask.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InCreate;
}());
var OutCreateHelpers = (function () {
    function OutCreateHelpers() {
    }
    OutCreateHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutCreateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_beetle_1.ClusterizationTaskId(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutCreateHelpers;
}());
var InValidate = (function () {
    function InValidate(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.clusterTask = new services_beetle_1.ClusterizationTaskCreateData(data.clusterTask);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InValidate.prototype, "clusterTask", {
        get: function () {
            return this._clusterTask;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field clusterTask is not optional');
            }
            this._clusterTask = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InValidate.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InValidate.prototype.serialize = function () {
        return {
            clusterTask: this.clusterTask.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InValidate;
}());
var OutValidateHelpers = (function () {
    function OutValidateHelpers() {
    }
    OutValidateHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutValidateHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_beetle_1.ClusterizationTaskValidation(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutValidateHelpers;
}());
var InQueryTasks = (function () {
    function InQueryTasks(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.sortBy = data.sortBy.map(function (e) { return new services_beetle_1.ClusterizationTaskSort(e); });
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InQueryTasks.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryTasks.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sortBy is not optional');
            }
            this._sortBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryTasks.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryTasks.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryTasks.prototype.serialize = function () {
        var _this = this;
        return {
            iterator: this.iterator.serialize(),
            sortBy: this.sortBy.map(function (e) { return e.serialize(); }),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {}),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InQueryTasks;
}());
var OutQueryTasksHelpers = (function () {
    function OutQueryTasksHelpers() {
    }
    OutQueryTasksHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryTasksHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_beetle_1.ClusterizationTasksResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryTasksHelpers;
}());
var InRetrieveTask = (function () {
    function InRetrieveTask(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.taskId = new services_beetle_1.ClusterizationTaskId(data.taskId);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InRetrieveTask.prototype, "taskId", {
        get: function () {
            return this._taskId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field taskId is not optional');
            }
            this._taskId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRetrieveTask.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InRetrieveTask.prototype.serialize = function () {
        return {
            taskId: this.taskId.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InRetrieveTask;
}());
var OutRetrieveTaskHelpers = (function () {
    function OutRetrieveTaskHelpers() {
    }
    OutRetrieveTaskHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRetrieveTaskHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_beetle_1.ClusterizationTask(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRetrieveTaskHelpers;
}());
var InStart = (function () {
    function InStart(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.taskId = new services_beetle_1.ClusterizationTaskId(data.taskId);
        this.ingestionCfg = new services_beetle_1.IngestionConfig(data.ingestionCfg);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InStart.prototype, "taskId", {
        get: function () {
            return this._taskId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field taskId is not optional');
            }
            this._taskId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InStart.prototype, "ingestionCfg", {
        get: function () {
            return this._ingestionCfg;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field ingestionCfg is not optional');
            }
            this._ingestionCfg = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InStart.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InStart.prototype.serialize = function () {
        return {
            taskId: this.taskId.serialize(),
            ingestionCfg: this.ingestionCfg.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InStart;
}());
var OutStartHelpers = (function () {
    function OutStartHelpers() {
    }
    OutStartHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutStartHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_beetle_1.ClusterizationRunId(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutStartHelpers;
}());
var InStop = (function () {
    function InStop(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.taskId = new services_beetle_1.ClusterizationTaskId(data.taskId);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InStop.prototype, "taskId", {
        get: function () {
            return this._taskId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field taskId is not optional');
            }
            this._taskId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InStop.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InStop.prototype.serialize = function () {
        return {
            taskId: this.taskId.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InStop;
}());
var OutStopHelpers = (function () {
    function OutStopHelpers() {
    }
    OutStopHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutStopHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutStopHelpers;
}());
var InRetrieveLatestRun = (function () {
    function InRetrieveLatestRun(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.taskId = new services_beetle_1.ClusterizationTaskId(data.taskId);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InRetrieveLatestRun.prototype, "taskId", {
        get: function () {
            return this._taskId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field taskId is not optional');
            }
            this._taskId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRetrieveLatestRun.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InRetrieveLatestRun.prototype.serialize = function () {
        return {
            taskId: this.taskId.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InRetrieveLatestRun;
}());
var OutRetrieveLatestRunHelpers = (function () {
    function OutRetrieveLatestRunHelpers() {
    }
    OutRetrieveLatestRunHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': typeof either.value !== 'undefined' ? either.value.serialize() : undefined
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRetrieveLatestRunHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(typeof content !== 'undefined' ? new services_beetle_1.ClusterizationRun(content) : undefined);
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRetrieveLatestRunHelpers;
}());
var InRetrieveRun = (function () {
    function InRetrieveRun(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.runId = new services_beetle_1.ClusterizationRunId(data.runId);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InRetrieveRun.prototype, "runId", {
        get: function () {
            return this._runId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field runId is not optional');
            }
            this._runId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InRetrieveRun.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InRetrieveRun.prototype.serialize = function () {
        return {
            runId: this.runId.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InRetrieveRun;
}());
var OutRetrieveRunHelpers = (function () {
    function OutRetrieveRunHelpers() {
    }
    OutRetrieveRunHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': typeof either.value !== 'undefined' ? either.value.serialize() : undefined
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutRetrieveRunHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(typeof content !== 'undefined' ? new services_beetle_1.ClusterizationRun(content) : undefined);
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutRetrieveRunHelpers;
}());
var InQueryRuns = (function () {
    function InQueryRuns(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.taskId = new services_beetle_1.ClusterizationTaskId(data.taskId);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.sortBy = data.sortBy.map(function (e) { return new services_beetle_1.ClusterizationRunSort(e); });
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InQueryRuns.prototype, "taskId", {
        get: function () {
            return this._taskId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field taskId is not optional');
            }
            this._taskId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryRuns.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryRuns.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sortBy is not optional');
            }
            this._sortBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryRuns.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryRuns.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryRuns.prototype.serialize = function () {
        var _this = this;
        return {
            taskId: this.taskId.serialize(),
            iterator: this.iterator.serialize(),
            sortBy: this.sortBy.map(function (e) { return e.serialize(); }),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {}),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InQueryRuns;
}());
var OutQueryRunsHelpers = (function () {
    function OutQueryRunsHelpers() {
    }
    OutQueryRunsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryRunsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_beetle_1.ClusterizationRunsResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryRunsHelpers;
}());
var InQueryAllRuns = (function () {
    function InQueryAllRuns(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.sortBy = data.sortBy.map(function (e) { return new services_beetle_1.ClusterizationRunSort(e); });
        this.filterBy = Object.keys(data.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.deserialize(data.filterBy[current]); return previous; }, {});
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InQueryAllRuns.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryAllRuns.prototype, "sortBy", {
        get: function () {
            return this._sortBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field sortBy is not optional');
            }
            this._sortBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryAllRuns.prototype, "filterBy", {
        get: function () {
            return this._filterBy;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field filterBy is not optional');
            }
            this._filterBy = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryAllRuns.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryAllRuns.prototype.serialize = function () {
        var _this = this;
        return {
            iterator: this.iterator.serialize(),
            sortBy: this.sortBy.map(function (e) { return e.serialize(); }),
            filterBy: Object.keys(this.filterBy).reduce(function (previous, current) { previous[current] = octopus_common_1.FilterHelpers.serialize(_this.filterBy[current]); return previous; }, {}),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InQueryAllRuns;
}());
var OutQueryAllRunsHelpers = (function () {
    function OutQueryAllRunsHelpers() {
    }
    OutQueryAllRunsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryAllRunsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_beetle_1.ClusterizationRunsResponse(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryAllRunsHelpers;
}());
var InDelete = (function () {
    function InDelete(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.taskId = new services_beetle_1.ClusterizationTaskId(data.taskId);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InDelete.prototype, "taskId", {
        get: function () {
            return this._taskId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field taskId is not optional');
            }
            this._taskId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDelete.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InDelete.prototype.serialize = function () {
        return {
            taskId: this.taskId.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InDelete;
}());
var OutDeleteHelpers = (function () {
    function OutDeleteHelpers() {
    }
    OutDeleteHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteHelpers;
}());
var InDeleteRuns = (function () {
    function InDeleteRuns(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.runIds = data.runIds.map(function (e) { return new services_beetle_1.ClusterizationRunId(e); });
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InDeleteRuns.prototype, "runIds", {
        get: function () {
            return this._runIds;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field runIds is not optional');
            }
            this._runIds = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InDeleteRuns.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InDeleteRuns.prototype.serialize = function () {
        return {
            runIds: this.runIds.map(function (e) { return e.serialize(); }),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InDeleteRuns;
}());
var OutDeleteRunsHelpers = (function () {
    function OutDeleteRunsHelpers() {
    }
    OutDeleteRunsHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutDeleteRunsHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_shared_1.CommonSuccess(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutDeleteRunsHelpers;
}());
var InQueryReport = (function () {
    function InQueryReport(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.runId = new services_beetle_1.ClusterizationRunId(data.runId);
        this.minClusterSize = data.minClusterSize;
        this.maxClusterSize = data.maxClusterSize;
        this.limitClusterDocuments = data.limitClusterDocuments;
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InQueryReport.prototype, "runId", {
        get: function () {
            return this._runId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field runId is not optional');
            }
            this._runId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryReport.prototype, "minClusterSize", {
        get: function () {
            return this._minClusterSize;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field minClusterSize is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field minClusterSize expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field minClusterSize is expected to be an integer, got ' + value);
            }
            this._minClusterSize = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryReport.prototype, "maxClusterSize", {
        get: function () {
            return this._maxClusterSize;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field maxClusterSize is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field maxClusterSize expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field maxClusterSize is expected to be an integer, got ' + value);
            }
            this._maxClusterSize = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryReport.prototype, "limitClusterDocuments", {
        get: function () {
            return this._limitClusterDocuments;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field limitClusterDocuments is not optional');
            }
            if (typeof value !== 'number') {
                throw new Error('Field limitClusterDocuments expects type number, got ' + value);
            }
            if (value % 1 !== 0) {
                throw new Error('Field limitClusterDocuments is expected to be an integer, got ' + value);
            }
            if (value < -32768) {
                throw new Error('Field limitClusterDocuments is expected to be not less than -32768, got ' + value);
            }
            if (value > 32767) {
                throw new Error('Field limitClusterDocuments is expected to be not greater than 32767, got ' + value);
            }
            this._limitClusterDocuments = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryReport.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryReport.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryReport.prototype.serialize = function () {
        return {
            runId: this.runId.serialize(),
            minClusterSize: this.minClusterSize,
            maxClusterSize: this.maxClusterSize,
            limitClusterDocuments: this.limitClusterDocuments,
            iterator: this.iterator.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InQueryReport;
}());
var OutQueryReportHelpers = (function () {
    function OutQueryReportHelpers() {
    }
    OutQueryReportHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryReportHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_beetle_1.ClusterizationReport(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryReportHelpers;
}());
var InQueryCluster = (function () {
    function InQueryCluster(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.runId = new services_beetle_1.ClusterizationRunId(data.runId);
        this.clusterId = new services_beetle_1.ClusterId(data.clusterId);
        this.iterator = new services_shared_1.OffsetLimit(data.iterator);
        this.env = octopus_common_1.Environment[data.env];
    }
    Object.defineProperty(InQueryCluster.prototype, "runId", {
        get: function () {
            return this._runId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field runId is not optional');
            }
            this._runId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryCluster.prototype, "clusterId", {
        get: function () {
            return this._clusterId;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field clusterId is not optional');
            }
            this._clusterId = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryCluster.prototype, "iterator", {
        get: function () {
            return this._iterator;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field iterator is not optional');
            }
            this._iterator = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InQueryCluster.prototype, "env", {
        get: function () {
            return this._env;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field env is not optional');
            }
            this._env = value;
        },
        enumerable: false,
        configurable: true
    });
    InQueryCluster.prototype.serialize = function () {
        return {
            runId: this.runId.serialize(),
            clusterId: this.clusterId.serialize(),
            iterator: this.iterator.serialize(),
            env: octopus_common_1.Environment[this.env]
        };
    };
    return InQueryCluster;
}());
var OutQueryClusterHelpers = (function () {
    function OutQueryClusterHelpers() {
    }
    OutQueryClusterHelpers.serialize = function (either) {
        return either.isRight() ? {
            'Success': either.value.serialize()
        } : {
            'Failure': either.value.serialize()
        };
    };
    OutQueryClusterHelpers.deserialize = function (data) {
        var id = Object.keys(data)[0];
        var content = data[id];
        switch (id) {
            case 'Success': return new irt_1.Right(new services_beetle_1.ClusterReport(content));
            case 'Failure': return new irt_1.Left(new services_shared_1.GenericFailure(content));
            default: throw new Error("Unexpected key ".concat(id, " in either object."));
        }
    };
    return OutQueryClusterHelpers;
}());
var AudienceRequestsClusterizationServiceClient = (function () {
    function AudienceRequestsClusterizationServiceClient(transport) {
        this._transport = transport;
    }
    AudienceRequestsClusterizationServiceClient.prototype.getPackageName = function () { return AudienceRequestsClusterizationServiceClient.PackageName; };
    AudienceRequestsClusterizationServiceClient.prototype.getClassName = function () { return AudienceRequestsClusterizationServiceClient.ClassName; };
    AudienceRequestsClusterizationServiceClient.prototype.getFullClassName = function () { return AudienceRequestsClusterizationServiceClient.FullClassName; };
    AudienceRequestsClusterizationServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.create = function (clusterTask, env) {
        var _this = this;
        var __data = new InCreate();
        __data.clusterTask = clusterTask;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'create', __data)
                .then(function (data) {
                try {
                    resolve(OutCreateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.validate = function (clusterTask, env) {
        var _this = this;
        var __data = new InValidate();
        __data.clusterTask = clusterTask;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'validate', __data)
                .then(function (data) {
                try {
                    resolve(OutValidateHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.queryTasks = function (iterator, sortBy, filterBy, env) {
        var _this = this;
        var __data = new InQueryTasks();
        __data.iterator = iterator;
        __data.sortBy = sortBy;
        __data.filterBy = filterBy;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'queryTasks', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryTasksHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.retrieveTask = function (taskId, env) {
        var _this = this;
        var __data = new InRetrieveTask();
        __data.taskId = taskId;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'retrieveTask', __data)
                .then(function (data) {
                try {
                    resolve(OutRetrieveTaskHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.start = function (taskId, ingestionCfg, env) {
        var _this = this;
        var __data = new InStart();
        __data.taskId = taskId;
        __data.ingestionCfg = ingestionCfg;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'start', __data)
                .then(function (data) {
                try {
                    resolve(OutStartHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.stop = function (taskId, env) {
        var _this = this;
        var __data = new InStop();
        __data.taskId = taskId;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'stop', __data)
                .then(function (data) {
                try {
                    resolve(OutStopHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.retrieveLatestRun = function (taskId, env) {
        var _this = this;
        var __data = new InRetrieveLatestRun();
        __data.taskId = taskId;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'retrieveLatestRun', __data)
                .then(function (data) {
                try {
                    resolve(OutRetrieveLatestRunHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.retrieveRun = function (runId, env) {
        var _this = this;
        var __data = new InRetrieveRun();
        __data.runId = runId;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'retrieveRun', __data)
                .then(function (data) {
                try {
                    resolve(OutRetrieveRunHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.queryRuns = function (taskId, iterator, sortBy, filterBy, env) {
        var _this = this;
        var __data = new InQueryRuns();
        __data.taskId = taskId;
        __data.iterator = iterator;
        __data.sortBy = sortBy;
        __data.filterBy = filterBy;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'queryRuns', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryRunsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.queryAllRuns = function (iterator, sortBy, filterBy, env) {
        var _this = this;
        var __data = new InQueryAllRuns();
        __data.iterator = iterator;
        __data.sortBy = sortBy;
        __data.filterBy = filterBy;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'queryAllRuns', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryAllRunsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.delete = function (taskId, env) {
        var _this = this;
        var __data = new InDelete();
        __data.taskId = taskId;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'delete', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.deleteRuns = function (runIds, env) {
        var _this = this;
        var __data = new InDeleteRuns();
        __data.runIds = runIds;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'deleteRuns', __data)
                .then(function (data) {
                try {
                    resolve(OutDeleteRunsHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.queryReport = function (runId, minClusterSize, maxClusterSize, limitClusterDocuments, iterator, env) {
        var _this = this;
        var __data = new InQueryReport();
        __data.runId = runId;
        __data.minClusterSize = minClusterSize;
        __data.maxClusterSize = maxClusterSize;
        __data.limitClusterDocuments = limitClusterDocuments;
        __data.iterator = iterator;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'queryReport', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryReportHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.prototype.queryCluster = function (runId, clusterId, iterator, env) {
        var _this = this;
        var __data = new InQueryCluster();
        __data.runId = runId;
        __data.clusterId = clusterId;
        __data.iterator = iterator;
        __data.env = env;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AudienceRequestsClusterizationServiceClient.ClassName, 'queryCluster', __data)
                .then(function (data) {
                try {
                    resolve(OutQueryClusterHelpers.deserialize(data));
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AudienceRequestsClusterizationServiceClient.PackageName = 'net.playq.octopus2.audience';
    AudienceRequestsClusterizationServiceClient.ClassName = 'AudienceRequestsClusterizationService';
    AudienceRequestsClusterizationServiceClient.FullClassName = 'net.playq.octopus2.audience.AudienceRequestsClusterizationService';
    return AudienceRequestsClusterizationServiceClient;
}());
exports.AudienceRequestsClusterizationServiceClient = AudienceRequestsClusterizationServiceClient;
var AudienceRequestsClusterizationServiceDispatcher = (function () {
    function AudienceRequestsClusterizationServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    AudienceRequestsClusterizationServiceDispatcher.prototype.getSupportedService = function () {
        return 'AudienceRequestsClusterizationService';
    };
    AudienceRequestsClusterizationServiceDispatcher.prototype.getSupportedMethods = function () {
        return AudienceRequestsClusterizationServiceDispatcher.methods;
    };
    AudienceRequestsClusterizationServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "create": {
                var obj_1 = new InCreate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.create(context, obj_1.clusterTask, obj_1.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutCreateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "validate": {
                var obj_2 = new InValidate(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.validate(context, obj_2.clusterTask, obj_2.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutValidateHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryTasks": {
                var obj_3 = new InQueryTasks(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryTasks(context, obj_3.iterator, obj_3.sortBy, obj_3.filterBy, obj_3.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryTasksHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "retrieveTask": {
                var obj_4 = new InRetrieveTask(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.retrieveTask(context, obj_4.taskId, obj_4.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRetrieveTaskHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "start": {
                var obj_5 = new InStart(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.start(context, obj_5.taskId, obj_5.ingestionCfg, obj_5.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutStartHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "stop": {
                var obj_6 = new InStop(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.stop(context, obj_6.taskId, obj_6.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutStopHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "retrieveLatestRun": {
                var obj_7 = new InRetrieveLatestRun(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.retrieveLatestRun(context, obj_7.taskId, obj_7.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRetrieveLatestRunHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "retrieveRun": {
                var obj_8 = new InRetrieveRun(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.retrieveRun(context, obj_8.runId, obj_8.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutRetrieveRunHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryRuns": {
                var obj_9 = new InQueryRuns(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryRuns(context, obj_9.taskId, obj_9.iterator, obj_9.sortBy, obj_9.filterBy, obj_9.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryRunsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryAllRuns": {
                var obj_10 = new InQueryAllRuns(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryAllRuns(context, obj_10.iterator, obj_10.sortBy, obj_10.filterBy, obj_10.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryAllRunsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "delete": {
                var obj_11 = new InDelete(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.delete(context, obj_11.taskId, obj_11.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "deleteRuns": {
                var obj_12 = new InDeleteRuns(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.deleteRuns(context, obj_12.runIds, obj_12.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutDeleteRunsHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryReport": {
                var obj_13 = new InQueryReport(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryReport(context, obj_13.runId, obj_13.minClusterSize, obj_13.maxClusterSize, obj_13.limitClusterDocuments, obj_13.iterator, obj_13.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryReportHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "queryCluster": {
                var obj_14 = new InQueryCluster(this.marshaller.Unmarshal(data));
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.queryCluster(context, obj_14.runId, obj_14.clusterId, obj_14.iterator, obj_14.env)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(OutQueryClusterHelpers.serialize(res));
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by AudienceRequestsClusterizationServiceDispatcher."));
        }
    };
    AudienceRequestsClusterizationServiceDispatcher.methods = [
        "create",
        "validate",
        "queryTasks",
        "retrieveTask",
        "start",
        "stop",
        "retrieveLatestRun",
        "retrieveRun",
        "queryRuns",
        "queryAllRuns",
        "delete",
        "deleteRuns",
        "queryReport",
        "queryCluster"
    ];
    return AudienceRequestsClusterizationServiceDispatcher;
}());
exports.AudienceRequestsClusterizationServiceDispatcher = AudienceRequestsClusterizationServiceDispatcher;
var AudienceRequestsClusterizationServiceServer = (function (_super) {
    __extends(AudienceRequestsClusterizationServiceServer, _super);
    function AudienceRequestsClusterizationServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    AudienceRequestsClusterizationServiceServer.prototype.create = function (context, clusterTask, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.validate = function (context, clusterTask, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.queryTasks = function (context, iterator, sortBy, filterBy, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.retrieveTask = function (context, taskId, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.start = function (context, taskId, ingestionCfg, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.stop = function (context, taskId, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.retrieveLatestRun = function (context, taskId, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.retrieveRun = function (context, runId, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.queryRuns = function (context, taskId, iterator, sortBy, filterBy, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.queryAllRuns = function (context, iterator, sortBy, filterBy, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.delete = function (context, taskId, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.deleteRuns = function (context, runIds, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.queryReport = function (context, runId, minClusterSize, maxClusterSize, limitClusterDocuments, iterator, env) {
        throw new Error('Not implemented.');
    };
    AudienceRequestsClusterizationServiceServer.prototype.queryCluster = function (context, runId, clusterId, iterator, env) {
        throw new Error('Not implemented.');
    };
    return AudienceRequestsClusterizationServiceServer;
}(AudienceRequestsClusterizationServiceDispatcher));
exports.AudienceRequestsClusterizationServiceServer = AudienceRequestsClusterizationServiceServer;
//# sourceMappingURL=AudienceRequestsClusterizationService.js.map